import { IEmployee, IGetEmployeeResponse } from "@source/api/models/employeeModels";
import { TableData } from "@source/utils/models/adminModels";
import { makeAutoObservable } from "mobx";

class AdminStore {
  employees: IEmployee[] = [];
  employeesTotalCount: number = 0;
  editEmployee: IEmployee | null = null;
  focusEmployee: IEmployee | null = null;
  focusEmployeePage: number | null = null;

  private formatEmployee(employee: IEmployee): TableData {
    const {firstName, lastName, email, phoneNumber, photo, invitations, accountType, _id, account, isDisabled, isConfirmed, loginDate} = employee;
    
    const formatedEmployee = {
      name: `${firstName} ${lastName}`,
      firstName: firstName,
      lastName: lastName,
      email: email,
      phoneNumber: phoneNumber,
      photo: photo,
      accountType:accountType,
      _id: _id,
      position: account.position,
      role: account.role,
      stuffId: account.stuffId,
      invitation: invitations[0],
      homes: account.nursingHomes.map((nursingHome) => nursingHome._id),
      homesNames: account.nursingHomes.map((nursingHome) => nursingHome.name),
      homePermissionIds: account.permissions.homes?.reduce((accum, permissionHome) => ({...accum, [permissionHome.home._id]: permissionHome.permissions.concat()}), {}) || {},
      orgPermissionIds: account.permissions.organization?.permissions.concat() || [],
      isDisabled,
      isConfirmed,
      loginDate: loginDate || "",
      actions: null
    }

    return formatedEmployee;
  }

  constructor() {
    makeAutoObservable(this);
  }

  setFocusEmployee(employeeId: string | null) {
    this.focusEmployee = this.employees.find((employee) => employee._id === employeeId) || null;
  }

  getFocusEmployee() {
    return this.focusEmployee;
  }

  setFocusEmployeePage(page: number | null) {
    this.focusEmployeePage = page;
  }

  getFocusEmployeePage() {
    return this.focusEmployeePage;
  }

  setEmployees(employees: IGetEmployeeResponse) {
    this.employees = employees.users;
    this.employeesTotalCount = employees.totalCount;
  }

  setEditEmployee(employeeId: string | null) {
    this.editEmployee = this.employees.find((employee) => employee._id === employeeId) || null;
  }

  getEditEmployee() {
    return this.editEmployee;
  }

  getFormatedEditEmployee(): TableData | null {
    if (this.editEmployee) {
      return this.formatEmployee(this.editEmployee);
    }

    return null;
  }

  getFormatedEmployees(): TableData[] {
    return this.employees.map((employee) => {
      return this.formatEmployee(employee);
    })
  }

  getEmployees(): IEmployee[] {
    return this.employees;
  }

  getEmployeesTotalCount(): number {
    return this.employeesTotalCount;
  }

  filterIsDisabledEmployee(employeeId: string) {
    this.employees = this.employees.filter((employee) => employee._id !== employeeId);
    this.employeesTotalCount--;
  }
}

export default new AdminStore();